import { useCallback, useMemo, useState } from 'react';
import { useGetNotificationsQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/NotificationsRpc.hooks';
import { getPortalAccountId, getPortalInstanceId } from '../utils/metadata';
function toNotificationType(rpcType) {
  switch (rpcType) {
    case 'PAYMENT_FAILED':
    case 'INVOICE_UNPAID':
    case 'SUBSCRIPTION_CANCELLATION_REQUESTED':
      return 'BILLING';
    case 'DOCUMENT_SHARED':
    case 'ACCESS_GRANTED':
    case 'PORTAL_ACTIVITY':
      return 'DEALS';
    default:
      return null;
  }
}
function toPortalNotification(rpc) {
  var _rpc$ctaLink;
  const notificationType = toNotificationType(String(rpc.notificationType));
  if (!notificationType) return null;
  return {
    id: rpc.id,
    portalInstanceId: rpc.portalInstanceId,
    notificationType,
    title: rpc.title,
    body: rpc.body,
    ctaLink: (_rpc$ctaLink = rpc.ctaLink) !== null && _rpc$ctaLink !== void 0 ? _rpc$ctaLink : null,
    createdAt: rpc.createdAt,
    isRead: rpc.isRead
  };
}
export function useNotifications({
  limit
}) {
  var _data$totalCount, _data$unreadCount;
  const [loadingMore, setLoadingMore] = useState(false);
  const {
    data,
    loading,
    error,
    fetchMore
  } = useGetNotificationsQuery({
    variables: {
      offset: 0,
      limit,
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId()
    },
    fetchPolicy: 'cache-and-network'
  });
  const totalCount = (_data$totalCount = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _data$totalCount !== void 0 ? _data$totalCount : 0;
  const unreadCount = (_data$unreadCount = data === null || data === void 0 ? void 0 : data.unreadCount) !== null && _data$unreadCount !== void 0 ? _data$unreadCount : 0;
  const notifications = useMemo(() => {
    var _data$notifications;
    return ((_data$notifications = data === null || data === void 0 ? void 0 : data.notifications) !== null && _data$notifications !== void 0 ? _data$notifications : []).map(toPortalNotification).filter(n => n !== null);
  }, [data === null || data === void 0 ? void 0 : data.notifications]);
  const loadMore = useCallback(() => {
    if (loadingMore) return;
    setLoadingMore(true);
    fetchMore({
      variables: {
        offset: notifications.length
      },
      updateQuery: (prev, {
        fetchMoreResult
      }) => {
        var _prev$result$notifica;
        if (!fetchMoreResult) return prev;
        return {
          result: Object.assign({}, fetchMoreResult.result, {
            notifications: [...((_prev$result$notifica = prev.result.notifications) !== null && _prev$result$notifica !== void 0 ? _prev$result$notifica : []), ...fetchMoreResult.result.notifications]
          })
        };
      }
    }).catch(console.error).finally(() => setLoadingMore(false));
  }, [loadingMore, fetchMore, notifications.length]);
  return {
    notifications,
    unreadCount,
    totalCount,
    loading,
    loadingMore,
    hasMore: notifications.length < totalCount,
    error: !!error,
    loadMore,
    // TODO: implement markAsRead
    markAsRead: () => {},
    // TODO: implement markAllAsRead
    markAllAsRead: () => {},
    // TODO: implement remove or dismiss the notification
    remove: () => {}
  };
}